import axios from 'axios';
import { GRANT_HEADER, LANDING_HEADER } from '@/lib/recordAccess/grantHeaders';
import { LANDING_QUERY_PARAMS } from '@/lib/recordAccess/landingRecords';

const STORAGE_KEY = 'pennie_record_grant';

function storedGrant(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

function storeGrant(token: string) {
  try {
    localStorage.setItem(STORAGE_KEY, token);
  } catch {
    // storage blocked: the grant lasts for this page only
  }
}

function landingPage(): string {
  const { pathname, search } = window.location;
  const params = new URLSearchParams(search);
  const kept = new URLSearchParams();
  for (const name of LANDING_QUERY_PARAMS) {
    const value = params.get(name);
    if (value) kept.set(name, value);
  }
  const query = kept.toString();
  return query ? `${pathname}?${query}` : pathname;
}

let pageGrant: string | null = null;

export const internalApi = axios.create();

export function recordAccessHeaders(): Record<string, string> {
  const token = storedGrant() ?? pageGrant;
  return {
    ...(token ? { [GRANT_HEADER]: token } : {}),
    [LANDING_HEADER]: landingPage(),
  };
}

internalApi.interceptors.request.use((config) => {
  if (typeof window === 'undefined') return config;
  for (const [name, value] of Object.entries(recordAccessHeaders())) {
    config.headers.set(name, value);
  }
  return config;
});

internalApi.interceptors.response.use(
  (response) => {
    const token = response.headers[GRANT_HEADER];
    if (typeof window !== 'undefined' && typeof token === 'string') {
      pageGrant = token;
      storeGrant(token);
    }
    return response;
  },
  (error) => {
    // A send that needs SSN and birth date on an old record: go prove it with the
    // last 4, which returns to this page with t. The call never settles here.
    const proofPath = error?.response?.data?.proofPath;
    if (
      typeof window !== 'undefined' &&
      error?.response?.status === 403 &&
      typeof proofPath === 'string' &&
      /^\/(verify|get-offers)\/[a-zA-Z0-9]{15,18}\?next=/.test(proofPath)
    ) {
      window.location.assign(proofPath);
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);
